import { gql, QueryHookOptions, QueryResult, useQuery } from '@apollo/client';

import { PaginatedDetectionSummaryInsights } from '../../entities/types/entityTable';
import { SortParameterInput } from '@investigator/shared/generated/graphql';

export interface IGetTopDetectionEntitiesInsightsPaginated {
  getTopDetectionEntitiesInsightsPaginated: PaginatedDetectionSummaryInsights;
}

export interface GetTopDetectionEntitiesInsightsPaginatedVariables {
  start: number;
  end: number;
  tenant?: string;
  tenant_entity?: string;
  include_ai_insights?: boolean;
  group_by?: string;
  offset?: number;
  size?: number;
  sort?: SortParameterInput[];
}

export const GET_TOP_DETECTION_ENTITIES_INSIGHTS_PAGINATED = gql`
  query getTopDetectionEntitiesInsightsPaginated(
    $start: Float!
    $end: Float!
    $tenant: String
    $include_ai_insights: Boolean
    $offset: Int
    $size: Int
    $sort: [SortParameterInput]
  ) {
    getTopDetectionEntitiesInsightsPaginated(
      start: $start
      end: $end
      offset: $offset
      size: $size
      sort: $sort
      tenant: $tenant
      include_ai_insights: $include_ai_insights
    ) {
      offset
      size
      summary_insights {
        total_detections
        entity_id
        entity_name
        entity_category
        entity_type
        max_severity
        tenant
        tenant_entity
        detection_counts_by_mitre_tactics {
          mitre_tactic
          detection_count
        }
        detection_counts_by_status {
          open
          closed
        }
        detection_counts_by_severity_level {
          low
          medium
          high
        }
        comment_count
        entity_locality
        ai_insights {
          ai_insight_verdict
          short_description
          ai_insight_report_id
          created_timestamp
        }
        most_severe_alert_category
      }
      total_items
    }
  }
`;
/* eslint-enable graphql/template-strings */

export const useGetTopDetectionEntitiesInsightsPaginated = (
  options: QueryHookOptions<
    IGetTopDetectionEntitiesInsightsPaginated,
    GetTopDetectionEntitiesInsightsPaginatedVariables
  >,
): QueryResult<
  IGetTopDetectionEntitiesInsightsPaginated,
  GetTopDetectionEntitiesInsightsPaginatedVariables
> => {
  return useQuery<
    IGetTopDetectionEntitiesInsightsPaginated,
    GetTopDetectionEntitiesInsightsPaginatedVariables
  >(GET_TOP_DETECTION_ENTITIES_INSIGHTS_PAGINATED, options);
};
